/* eslint-disable max-len */
/* eslint-disable no-restricted-syntax */

import DisplayRequirements from './models/DisplayRequirements';

export default class RequirementsMetPolicy {
  static questionHasMetRequirements(requirements: DisplayRequirements, branch, submission): boolean {
    const groups = Array.isArray(requirements.list) ? requirements.list : [requirements.list];

    let matches = 0;
    groups.forEach((group) => {
      if (group.operator) {
        if (RequirementsMetPolicy.questionHasMetRequirements(group, branch, submission)) {
          matches += 1;
        }
      } else if (RequirementsMetPolicy.isRequirementGroupMet(group, branch, submission)) {
        matches += 1;
      }
    });

    if (requirements.operator === 'OR') {
      return matches > 0;
    }

    return matches === requirements.list.length;
  }

  public static notOnlyVirtualPlatformSelected(submission) {
    if (!submission.root['4_45']) {
      return true;
    }
    let values = Object.entries(submission.root['4_45']);
    values = values.filter((a) => a[1] === true);
    if (values.length === 1) {
      return values.filter((a) => a[0] === '5').length === 0;
    }
    return true;
  }

  public static onlyVirtualPlatformSelected(submission) {
    return !this.notOnlyVirtualPlatformSelected(submission);
  }

  public static adultsOnly(submission) {
    if (!submission.root['2_1']) {
      return false;
    }
    let values = Object.entries(submission.root['2_1']);
    values = values.filter((a) => a[1] === true);
    if (!values.length) {
      return false;
    }
    const options = values.map((a) => a[0]);
    const invalid = options.filter((a) => a !== '6' && a !== '7');
    return !invalid.length;
  }

  public static handbookOnly(submission) {
    if (!submission.root['4_16']) {
      return false;
    }
    let values = Object.entries(submission.root['4_16']);
    values = values.filter((a) => a[1] === true);
    if (!values.length) {
      return false;
    }
    const options = values.map((a) => a[0]);
    const invalid = options.filter((a) => a !== '10' && a !== '11' && a !== '12');
    return !invalid.length;
  }

  private static isRequirementGroupMet(requirementGroup, branch, submission): boolean {
    // @ts-ignore
    for (const [key, value] of Object.entries(requirementGroup)) {

      if(key === "function") {
        if(typeof this[value] == 'function') {
          return this[value](submission);
        } else {
          console.error('custom display function not defined');
        }
      }

      // checkboxes
      if (typeof submission[branch][key] === 'object') {
        // value is specified
        if (value != null) {
          if (!Array.isArray(value)) {
            //count checked boxes for rank component
            if (typeof value === 'object' && 'count' in value) {
              let rankAnswerCount = 0;
              for (const [rankAnswerKey, rankAnswerValue] of Object.entries(submission[branch][key])) {
                if (submission[branch][key][rankAnswerKey] && value['valid_options'].includes(parseInt(rankAnswerKey))) {
                  rankAnswerCount++;
                }
              }
              return rankAnswerCount >= value['count'];
            }
            // single value is required
            // requires:
            //   - 3_1: 1
            return submission[branch][key][value as any];
          }
          // one of multiple values is required.
          // requires:
          //   - 3_1:
          //       - 1
          //       - 2
          for (const index in value) {
            if (submission[branch][key][value[index]]) {
              return true;
            }
          }
        } else {
          // no value specified any checked item will do
          // requires:
          //   - 3_1:
          for (const index in submission[branch][key]) {
            if (submission[branch][key][index] == true) {
              return true;
            }
          }
          return false;
        }
      }

      const values = Array.isArray(value) ? value : [value];
      for (const i in values) {
        if (values[i] == null) {
          if (submission[branch][key]) {
            return true;
          }
        } else if (submission[branch][key] == values[i]) {
          return true;
        }
      }
    }

    return false;
  }
}
